module.exports = __webpack_public_path__ + "img/header-engagementRings100Carat@2x.97382e7.jpg";